import { z } from 'zod';
import { BaseResponseSchema, } from './primitives.js';
import { DeviceInventoryStatusSchema, NonIotDeviceRecordSchema, OpsDeviceCategorySchema, } from './device-inventory.schemas.js';
export const TenantDeviceRecordSchema = NonIotDeviceRecordSchema.omit({
    claimCode: true,
    claimCodeExpiresAt: true,
}).extend({
    orderReference: z.string().nullable().optional(),
});
export const TenantDeviceListQuerySchema = z.object({
    deviceCategory: OpsDeviceCategorySchema.optional(),
    inventoryStatus: DeviceInventoryStatusSchema.optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const TenantDeviceListResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        devices: z.array(TenantDeviceRecordSchema),
        nextCursor: z.string().nullable().optional(),
        count: z.number().int(),
    }),
});
export const TenantUnclaimedDevicesResponseSchema = BaseResponseSchema.extend({
    data: z.array(TenantDeviceRecordSchema),
});
export const TenantDeviceDetailResponseSchema = BaseResponseSchema.extend({
    data: z.object({ device: TenantDeviceRecordSchema }),
});
export const ClaimOrderRequestSchema = z.object({
    claimCode: z.string().regex(/^[A-Z0-9]{4}-[A-Z0-9]{4}$/),
});
export const PendingShipmentSummarySchema = z.object({
    orderReference: z.string().min(1).max(64),
    expectedShipDate: z.string().nullable(),
    actualShipDate: z.string().nullable(),
    deviceCount: z.number().int(),
    deviceSummary: z.array(z.object({
        category: z.string(),
        count: z.number().int(),
    })),
});
export const PendingShipmentsResponseSchema = BaseResponseSchema.extend({
    data: z.object({ shipments: z.array(PendingShipmentSummarySchema) }),
});
//# sourceMappingURL=tenant-devices.schemas.js.map